// extracted by mini-css-extract-plugin
export var container = "_sn-0";
export var table = "_sn-2";
export var tableWrapper = "_sn-1";